// Cartões de contato (type=CONTACTS): um por contato, com nome, telefones, e-mail e
// empresa. Cada telefone traz "Copiar número" e "Iniciar conversa".
import { BriefcaseIcon, MailIcon, UserIcon } from '@/components/icons';
import { formatPhone } from '@/lib/utils/formatters';
import type { SharedContact } from '../api';
import { toE164Digits } from '../utils/phone';
import { PhoneActionButtons } from './PhoneActions';
import styles from './MessageBubbleParts.module.css';

/** Dígitos para as ações: BR normalizado, ou o número como veio (estrangeiro). */
function actionDigits(phone: { phone: string; waId: string | null }): string | null {
  const source = phone.waId || phone.phone;
  const br = toE164Digits(source);
  if (br) return br;
  const digits = source.replace(/\D/g, '');
  return digits.length >= 8 ? digits : null;
}

export function ContactsBubble({ contacts }: { contacts: SharedContact[] }) {
  return (
    <ul className={styles.contacts} aria-label="Contatos compartilhados">
      {contacts.map((c, i) => (
        <li key={`${c.name}-${i}`} className={styles.contactCard}>
          <div className={styles.contactHead}>
            <span className={styles.contactAvatar} aria-hidden="true">
              <UserIcon size={16} />
            </span>
            <span className={styles.contactName}>{c.name || 'Contato'}</span>
          </div>
          {c.phones.length === 0 && <span className={styles.contactMuted}>Sem telefone</span>}
          {c.phones.map((p, j) => {
            const digits = actionDigits(p);
            return (
              <div key={`${p.phone}-${j}`} className={styles.contactPhone}>
                <span className={styles.contactPhoneNumber}>
                  {formatPhone(p.phone)}
                  {p.type && <span className={styles.contactMuted}> · {p.type}</span>}
                </span>
                {digits && <PhoneActionButtons digits={digits} name={c.name || undefined} />}
              </div>
            );
          })}
          {c.emails.map((email) => (
            <span key={email} className={styles.contactLine}>
              <MailIcon size={14} />
              {email}
            </span>
          ))}
          {c.org && (
            <span className={styles.contactLine}>
              <BriefcaseIcon size={14} />
              {c.org}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
